// 官网接口打点

import axios from 'axios'
import {
  Toast
} from 'vant'
import {
  encryptSignData
} from '@/common/signature/encryptSign.js';

let BASE_URL = process.env.VUE_APP_HOME_BASEURL

var service = axios.create({
  baseURL: BASE_URL, // api的base_url
  timeout: 15000, // 超时时间
  retry: 3, //请求次数
  retryDelay: 1000, //请求间隙
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
})

// 添加请求拦截器
service.interceptors.request.use(
  function (config) {
	let isNoNeedEncrypt = Boolean(config.isNoNeedEncrypt); // 是否 不需要加密，默认加密
    // 签名封装
    if (process.env.NODE_ENV === 'development') {
      // 本地测试
      const notEncrypt = false; //不加密
      config.data = encryptSignData(
        config.data,
        null,
        notEncrypt
      );
      config.data.reqEncrypt = 0;
      config.data.respEncrypt = 0;
      // config.data.reqEncrypt = 1; //测试
      // config.data.respEncrypt = 1; //测试
    } else {
      // 非本地测试加密
      config.data = encryptSignData(
        config.data,
        null,
        true
      );
      config.data.reqEncrypt = isNoNeedEncrypt ? 0 : 1;
      config.data.respEncrypt = isNoNeedEncrypt ? 0 : 1;
    }
    return config;
  },
  function (error) {
    Toast({
      message: '网络异常，请稍后重试!',
      duration: 1500,
      forbidClick: true,
    })
    return Promise.reject(error)
  }
)

// 添加响应拦截器
service.interceptors.response.use(
  function (response) {
    // 如果http状态码正常，则直接返回数据
    // console.log(response)
    // 如果不需要除了data之外的数据，可以直接 return response.data

    if (response && response.data) {
      return response.data
    }
  },
  function (error) {
    const status = error.response && error.response.status
    if (error.message === 'Network Error') {
      Toast({
        message: '网络连接超时',
        duration: 1500,
        forbidClick: true,
      })
      return Promise.reject(error)
    }
    if (status == 504) {
      Toast({
        message: '服务器被吃了⊙﹏⊙∥!',
        duration: 1500,
        forbidClick: true,
      })
    } else if (status == 404) {
      Toast({
        message: '请求不存在⊙﹏⊙∥!',
        duration: 1500,
        forbidClick: true,
      })
    } else if (status == 403) {
      Toast({
        message: '拒绝访问!',
        duration: 1500,
        forbidClick: true,
      })
    } else {
      // Toast({
      //   message: '未知错误!',
      //   duration: 1500,
      //   forbidClick: true,
      // })
      console.log(error);
      console.log('未知错误')
    }
    return Promise.reject(error)
  }
)

// 封装axios的get请求
export function home_get(url, params) {
  return new Promise((resolve, reject) => {
    service
    .get(url, params)
    .then((response) => {
      // resolve(response.data);
      resolve(response)
    })
    .catch((error) => {
      reject(error)
    })
  })
}

// 封装axios的post请求
export function home_post(url, params) {
  return new Promise((resolve, reject) => {
    service
    .post(url, params)
    .then((response) => {
      // resolve(response.data);
      resolve(response)
    })
    .catch((error) => {
      reject(error)
    })
  })
}
